export enum JoinDirection {
	LEFT = 1,
	RIGHT = -1,
}
